import type { ReactNode } from 'react'
import { Box, Breadcrumbs, Button, CircularProgress, Link, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

export function PageHeader({
  titulo,
  subtitulo,
  trilha,
  acoes,
}: {
  titulo: string
  subtitulo?: string
  trilha?: Array<{ label: string; to?: string }>
  acoes?: ReactNode
}) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', md: 'center' }}
      gap={3}
      sx={{ mb: 6 }}
    >
      <Box>
        {trilha && (
          <Breadcrumbs sx={{ mb: 1 }}>
            {trilha.map((t) =>
              t.to ? (
                <Link key={t.label} component={RouterLink} to={t.to} underline="hover" variant="body2">
                  {t.label}
                </Link>
              ) : (
                <Typography key={t.label} variant="body2" color="text.secondary">
                  {t.label}
                </Typography>
              ),
            )}
          </Breadcrumbs>
        )}
        <Typography variant="h5">{titulo}</Typography>
        {subtitulo && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {subtitulo}
          </Typography>
        )}
      </Box>
      {acoes && <Stack direction="row" gap={2}>{acoes}</Stack>}
    </Stack>
  )
}

export function Carregando({ altura = 240 }: { altura?: number }) {
  return (
    <Box sx={{ display: 'grid', placeItems: 'center', minHeight: altura }}>
      <CircularProgress />
    </Box>
  )
}

export function EstadoVazio({
  titulo,
  descricao,
  acao,
}: {
  titulo: string
  descricao?: string
  acao?: { label: string; onClick: () => void }
}) {
  return (
    <Box sx={{ textAlign: 'center', py: 16, px: 6 }}>
      <Typography variant="h6" color="text.secondary">
        {titulo}
      </Typography>
      {descricao && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, maxWidth: 460, mx: 'auto' }}>
          {descricao}
        </Typography>
      )}
      {acao && (
        <Button variant="contained" sx={{ mt: 5 }} onClick={acao.onClick}>
          {acao.label}
        </Button>
      )}
    </Box>
  )
}

/** Cartao de numero do topo dos dashboards (KPI do Sneat: icone em quadrado soft
 *  a esquerda, numero grande, rotulo pequeno). */
export function CartaoNumero({
  valor,
  rotulo,
  cor = 'primary.main',
  icone,
}: {
  valor: ReactNode
  rotulo: string
  cor?: string
  icone?: ReactNode
}) {
  return (
    <Stack direction="row" alignItems="center" gap={3}>
      {icone && (
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: 1.5,
            display: 'grid',
            placeItems: 'center',
            bgcolor: cor,
            color: 'common.white',
            opacity: 0.9,
            flexShrink: 0,
          }}
        >
          {icone}
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" sx={{ lineHeight: 1.2 }}>
          {valor}
        </Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {rotulo}
        </Typography>
      </Box>
    </Stack>
  )
}
